<template>
  <div class="admin-panel">
    <div class="loader" v-if="loading"><div class="spinner"></div></div>
    <p class="hint">Системные инструкции ассистента "Лена" (l.fitness365.ru). Изменения применяются сразу после сохранения, без перезапуска.</p>
    <textarea v-model="lenaText" class="text-editor" rows="16" spellcheck="false"></textarea>
    <div class="actions">
      <button @click="reloadLena">Отменить изменения</button>
      <button class="primary" @click="saveLena">Сохранить</button>
    </div>
    <p v-if="lenaError" class="error">{{ lenaError }}</p>

    <hr class="divider" />

    <p class="hint">Системные инструкции чат-бота поддержки в мессенджере (WhatsApp/AskSupportAi). Изменения применяются сразу после сохранения, без перезапуска.</p>
    <textarea v-model="chatbotText" class="text-editor" rows="16" spellcheck="false"></textarea>
    <div class="actions">
      <button @click="reloadChatbot">Отменить изменения</button>
      <button class="primary" @click="saveChatbot">Сохранить</button>
    </div>
    <p v-if="chatbotError" class="error">{{ chatbotError }}</p>
  </div>
</template>

<script>
import { adminApi } from '../api/admin-api';
import Vue from 'vue';

export default {
  name: 'instructions-editor',
  data() {
    return {
      lenaText: '',
      lenaError: '',
      chatbotText: '',
      chatbotError: '',
      loading: false,
    };
  },
  methods: {
    async reloadLena() {
      this.loading = true;
      this.lenaError = '';
      try {
        const { data } = await adminApi.get('/instructions/lena');
        this.lenaText = data;
      } finally {
        this.loading = false;
      }
    },
    async saveLena() {
      this.lenaError = '';
      this.loading = true;
      try {
        await adminApi.put('/instructions/lena', { content: this.lenaText });
        Vue.toasted.show('Инструкции Лены сохранены и применены', { type: 'success', duration: 3000 });
      } finally {
        this.loading = false;
      }
    },
    async reloadChatbot() {
      this.loading = true;
      this.chatbotError = '';
      try {
        const { data } = await adminApi.get('/instructions/chatbot');
        this.chatbotText = data;
      } finally {
        this.loading = false;
      }
    },
    async saveChatbot() {
      this.chatbotError = '';
      this.loading = true;
      try {
        await adminApi.put('/instructions/chatbot', { content: this.chatbotText });
        Vue.toasted.show('Инструкции чат-бота сохранены и применены', { type: 'success', duration: 3000 });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.reloadLena();
    this.reloadChatbot();
  }
};
</script>

<style scoped>
.admin-panel {
  position: relative;
  padding: 10px;
}

.hint {
  font-size: 12px;
  color: #666;
}

.text-editor {
  width: 100%;
  box-sizing: border-box;
  font-family: monospace;
  font-size: 12px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.actions {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}

button {
  cursor: pointer;
}

button.primary {
  background: #f15540;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 8px 14px;
}

.error {
  color: #d94a36;
  font-size: 12px;
}

.divider {
  margin: 25px 0;
  border: none;
  border-top: 1px solid #e0e0e0;
}

.loader {
  position: absolute;
  top: 10px;
  right: 10px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0,0,0,0.1);
  border-left-color: #e74c3c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/instructions-editor.vue